export default "__VITE_ASSET__z3Wwv1nt__"